import { render } from "./ProductPrices.vue?vue&type=template&id=806d7322&scoped=true"
import script from "./ProductPrices.vue?vue&type=script&lang=js"
export * from "./ProductPrices.vue?vue&type=script&lang=js"

import "./ProductPrices.vue?vue&type=style&index=0&id=806d7322&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806d7322"]])

export default __exports__